import "@fontsource-variable/inter";
import "./styles/index.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { Bootstrap } from "./app/Bootstrap";

const container = document.getElementById("root");
if (!container) {
  throw new Error("The #root element is missing from index.html.");
}

createRoot(container).render(
  <StrictMode>
    <Bootstrap />
  </StrictMode>,
);
